module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/learn_site_icon-bd838ba7778c8447ffacf1db9782ca61.png";